module.exports = __webpack_public_path__ + "static/media/Prediction.30884dcc.png";